<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import { Col, Container, Row } from "sveltestrap";
  import { Button } from "sveltestrap";
</script>

<div class="smart-main">
  <!-- <img src="/images/common/product_banner.jpg" alt="배너 이미지" /> -->
  <img
    src="/images/system/consult/consult_simulator1.jpg"
    alt="시뮬레이터 제품소개 이미지1"
  />
  <Spacer size="5rem" />
  <div class="video" style="margin-top: 5px;">
    <div
      class="ytvideo-container"
      style="
  position: relative;

  margin: auto;
  height: auto;
  padding-top: 51%;
  "
    >
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/baOCzH-EgOo"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen=""
        style="z-index: 1; top: 0; left: 0; position: absolute; width: 100%; height: 100%;"
      />
    </div>
  </div>
  <Spacer size="5rem" />
  <img
    src="/images/system/consult/consult_simulator2.jpg"
    alt="시뮬레이터 제품소개 이미지2"
  />
  <Spacer size="5rem" />
</div>

<style lang="scss">
  .smart-main {
    text-align: center;
    width: 100%;
    margin-left: 50%;
    transform: translate(-50%, 10px);
  }
  .video {
    width: 80%;
    margin-left: 10%;
  }
  @media (min-width: 768px) {
    .smart-main {
      width: 1000px !important;
    }
    .video {
      width: 100% !important;
      margin-left: 0% !important;
    }
  }
  .video {
    padding: 0px;
  }
</style>
